import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';

export default class TooltipCube {
  constructor() {
    this.cubeLabel;
    this.cubePosition;
    this.cubeScale;
    this.createCubeWidthTooltip();
  }

  createCubeWidthTooltip() {
    const cubeHeightTooltip = document.createElement('div');
    cubeHeightTooltip.className = 'label';
    cubeHeightTooltip.style.marginTop = '-2em';
    cubeHeightTooltip.textContent = `500 mm`;
    this.cubeLabel = new CSS2DObject(cubeHeightTooltip);
    return this.cubeLabel;
  }

  setNewPosition(cubeScale = this.cubeScale, cubePosition = this.cubePosition){
    this.cubePosition = cubePosition;
    this.cubeScale = cubeScale
    this.cubeLabel.position.set(cubePosition.x + cubeScale, cubePosition.y + cubeScale, cubePosition.z)
  }
}